const en = {
  // Navigation
  nav_intro: 'About Us',
  nav_business: 'Our Business',
  nav_events: 'Industry Events',
  nav_team: 'Our Team',
  nav_achievements: 'Achievements',
  nav_contact: 'Contact Us',
  
  // Hero Section
  hero_main_title: 'Professional Apple',
  hero_main_subtitle: 'Global Trading Expert',
  hero_company_intro: 'Hong Kong BOJM Trading Co., Ltd. was established in ',
  hero_company_year: '2011',
  hero_company_desc: ', specializing in global Apple smartphone trading.',
  hero_business_desc: 'We specialize in ',
  hero_product_1: 'Apple Resource Phones',
  hero_product_2: 'New Apple Phones',
  hero_product_3: 'Used Apple Phones',
  hero_business_coverage: ' sales, with business coverage in Europe, Dubai, Latin America, Southeast Asia and other global markets.',
  hero_cta_contact: 'Contact Us',
  hero_cta_learn: 'Learn More',
  
  // About Section
  intro_title: 'About',
  intro_title_highlight: 'BOJM Trading',
  intro_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  intro_company_name_en: '香港博鑫貿易有限公司',
  intro_founded: 'Founded in ',
  intro_founded_year: '2011',
  intro_desc_1: ', we are a professional company specializing in global Apple smartphone trading. After more than a decade of development, we have become a trusted partner in the industry.',
  intro_desc_2: 'We specialize in ',
  intro_desc_3: ' sales. With extensive industry experience and a wide supply chain network, we provide quality products and services to global customers.',
  intro_stat_year: '2011',
  intro_stat_year_label: 'Year Established',
  intro_stat_coverage: '4+',
  intro_stat_coverage_label: 'Global Regions',
  intro_experience: '13+',
  intro_experience_label: 'Years of Experience',
  
  // Business Section
  business_title: 'Our',
  business_title_highlight: 'Business',
  business_subtitle: 'Specializing in global Apple smartphone trading, providing professional sales services for ',
  business_subtitle_bold_1: 'New Apple Phones',
  business_subtitle_bold_2: 'Apple Resource Phones',
  business_subtitle_bold_3: 'Used Apple Phones',
  business_subtitle_end: '',
  
  business_new_title: 'New Apple Phones',
  business_new_desc: 'Latest iPhone series products, brand new and sealed, authentic guarantee, with global warranty service.',
  business_new_feature_1: 'Brand New Sealed',
  business_new_feature_2: 'Authentic',
  business_new_feature_3: 'Global Warranty',
  
  business_resource_title: 'Apple Resource Phones',
  business_resource_desc: 'Quality resource phone sources, strictly inspected, cost-effective, suitable for bulk procurement and channel distribution.',
  business_resource_feature_1: 'Strict Inspection',
  business_resource_feature_2: 'Bulk Discount',
  business_resource_feature_3: 'Channel Advantage',
  
  business_used_title: 'Used Apple Phones',
  business_used_desc: 'Selected quality used iPhones, professionally tested and refurbished, reliable quality, affordable price, best value choice.',
  business_used_feature_1: 'Professional Testing',
  business_used_feature_2: 'Quality Guarantee',
  business_used_feature_3: 'Affordable Price',
  
  business_coverage_title: 'Global Business Coverage',
  business_coverage_subtitle: 'Our products and services span four core global markets',
  business_region_europe: 'Europe',
  business_region_europe_en: '歐洲',
  business_region_dubai: 'Dubai',
  business_region_dubai_en: '迪拜',
  business_region_latam: 'Latin America',
  business_region_latam_en: '拉美',
  business_region_sea: 'Southeast Asia',
  business_region_sea_en: '東南亞',
  
  // Events Section
  events_title: 'Industry',
  events_title_highlight: 'Events',
  events_subtitle: 'Actively participating in ',
  events_subtitle_bold: 'Hong Kong International Communication Electronics Commerce',
  events_subtitle_end: ' and other industry organizations, maintaining close ties with global partners',
  
  events_event1_title: 'HKICEC Annual Summit',
  events_event1_date: 'November 13, 2025',
  events_event1_desc: 'The inaugural ceremony and gala dinner was held with great success, attended by over 200 member companies. Hong Kong - The Hong Kong International Communication Electronics Commerce (HKICEC), jointly initiated by industry leaders, was officially established on November 13, 2025. The inaugural ceremony and gala dinner was held at the Hong Kong Convention and Exhibition Centre (New Wing), marking a new milestone for Hong Kong\'s communication electronics commerce industry. The event brought together over 200 member companies, as well as top 100 global companies, industry representatives from local, mainland China and overseas, policymakers and business leaders, creating a grand and enthusiastic atmosphere.',
  
  events_event2_title: 'HKICEC Exchange Activities',
  events_event2_date: 'November 13, 2025',
  events_event2_desc: 'Member company representatives gathered to discuss industry development trends and cooperation opportunities. The event was enthusiastic, with representatives from various companies conducting in-depth exchanges on the latest developments, market opportunities, and future development directions in the communication electronics commerce field, contributing wisdom and strength to promote the innovative development of Hong Kong\'s communication electronics commerce industry.',
  
  events_tag_1: 'Hong Kong International Communication Electronics Commerce',
  events_tag_2: 'Industry Summit',
  events_tag_3: 'International Exchange',
  events_member_badge: 'Member Unit',
  
  // Team Section
  team_title: 'Our',
  team_title_highlight: 'Core Team',
  team_subtitle: 'Experienced management team leading continuous development and innovation',
  
  team_ceo_name: 'Zhang Guosong',
  team_ceo_position: 'CEO / Chief Executive Officer',
  team_ceo_desc: 'With over 20 years of experience in the mobile phone industry, having worked closely with well-known brands such as Transsion and Xiaomi, possessing extensive experience and broad industry resources in mobile phone trading.',
  
  team_sales_name: 'Li Chengrui',
  team_sales_position: 'Sales & Operations Director',
  team_sales_desc: 'Responsible for formulating company sales strategies and operational management, leading the team to expand global markets, ensuring efficient business operations and continuous growth.',
  
  // Achievements Section
  achievements_title: 'Our',
  achievements_title_highlight: 'Achievements',
  achievements_subtitle: 'Continuous growth performance, witnessing our professional strength and market trust',
  
  achievements_last_year: '2 Billion',
  achievements_last_year_label: 'Last Year Sales',
  achievements_last_year_period: '2023 Annual Sales Performance',
  
  achievements_this_year: '5 Billion',
  achievements_this_year_label: 'This Year Sales',
  achievements_this_year_period: '2024 Annual Sales Performance',
  
  achievements_growth_title: 'Annual Growth Rate',
  achievements_growth_desc_1: 'From 2 billion in 2023 to 5 billion in 2024, we achieved an amazing growth of ',
  achievements_growth_rate: '150%',
  achievements_growth_desc_2: ', which fully demonstrates our market competitiveness and customer trust.',
  achievements_year_2023: '2023',
  achievements_year_2024: '2024',
  achievements_growth_indicator: '+150%',
  
  achievements_stat_experience: '13+',
  achievements_stat_experience_label: 'Years of Experience',
  achievements_stat_markets: '4+',
  achievements_stat_markets_label: 'Global Market Regions',
  achievements_stat_team: 'Professional',
  achievements_stat_team_label: 'Core Management Team',
  achievements_stat_quality: 'Quality',
  achievements_stat_quality_label: 'Products & Services',
  
  // Contact Section
  contact_title: 'Contact',
  contact_title_highlight: 'Us',
  contact_intro: 'Welcome to contact us, we will provide you with professional consulting services and quality product solutions.',
  
  contact_address_title: 'Company Address',
  contact_address_value: 'Room 2021, No.1 Hung To Road, Kwun Tong, Hong Kong',
  contact_address_value_en: '香港觀塘區鴻圖道1號2021室',
  
  contact_phone_title: 'Phone',
  contact_phone_value: '+852 6468 5009',
  
  contact_email_title: 'Email',
  contact_email_value: 'dragonlee03@163.com',
  
  contact_coverage_title: 'Business Coverage',
  contact_coverage_value: 'Europe · Dubai · Latin America · Southeast Asia',
  
  contact_hours_title: 'Business Hours',
  contact_hours_value: 'Monday - Friday 9:00 - 18:00',
  
  contact_form_name: 'Name',
  contact_form_name_placeholder: 'Please enter your name',
  contact_form_email: 'Email',
  contact_form_email_placeholder: 'Please enter your email',
  contact_form_phone: 'Phone',
  contact_form_phone_placeholder: 'Please enter your phone number',
  contact_form_company: 'Company Name',
  contact_form_company_placeholder: 'Please enter your company name',
  contact_form_message: 'Message',
  contact_form_message_placeholder: 'Please enter your message',
  contact_form_submit: 'Submit',
  contact_form_submitting: 'Submitting...',
  contact_form_success: 'Submitted successfully! We will contact you soon.',
  contact_form_error: 'Submission failed, please try again later.',
  contact_form_char_limit: '/500',
  
  // Footer
  footer_company_name: 'Hong Kong BOJM Trading Co., Ltd.',
  footer_company_name_en: '香港博鑫貿易有限公司',
  footer_company_desc: 'Specializing in global Apple smartphone trading, providing quality products and professional services to customers.',
  
  footer_quick_links: 'Quick Links',
  footer_link_about: 'About Us',
  footer_link_business: 'Our Business',
  footer_link_team: 'Our Team',
  footer_link_achievements: 'Achievements',
  footer_link_contact: 'Contact Us',
  
  footer_products_title: 'Products',
  footer_product_new: 'New Apple Phones',
  footer_product_resource: 'Apple Resource Phones',
  footer_product_used: 'Used Apple Phones',
  
  footer_regions_title: 'Coverage Regions',
  footer_region_europe: 'Europe',
  footer_region_dubai: 'Dubai',
  footer_region_latam: 'Latin America',
  footer_region_sea: 'Southeast Asia',
  
  footer_copyright: '© 2024 Hong Kong BOJM Trading Co., Ltd. 香港博鑫貿易有限公司 All Rights Reserved',
  footer_powered: 'Powered by Readdy',
};

export default en;
